import { toAddressFormValidationErrors } from "@/services/address-validation/address-validation-errors.mapper";
import type {
  AddressFieldKey,
  SuggestedAddress,
  ValidationError,
} from "@/services/address-validation/address-validation.types";
import type { CheckoutFormState } from "@/pages/Checkout/checkout-form.types";

export type CheckoutAddressPatch = Pick<
  CheckoutFormState,
  "addressLine1" | "addressLine2" | "addressLine3" | "city" | "citySubdivision1" | "country" | "county" | "postalCode"
>;

export const toCheckoutAddressPatch = (suggestion: SuggestedAddress): CheckoutAddressPatch => ({
  addressLine1: suggestion.line1 ?? "",
  addressLine2: suggestion.line2 ?? "",
  addressLine3: suggestion.line3 ?? "",
  city: suggestion.city ?? "",
  citySubdivision1: suggestion.state ?? "",
  country: suggestion.country ?? "",
  county: suggestion.county ?? "",
  postalCode: suggestion.zip ?? "",
});

/**
 * Maps ITShopHW's canonical `AddressFieldKey` vocabulary to this checkout
 * form's own field names (e.g. `state` -> `citySubdivision1`). Every
 * consuming form declares its own dictionary like this one.
 */
const CHECKOUT_FIELD_BY_ADDRESS_ELEMENT: Record<AddressFieldKey, keyof CheckoutFormState> = {
  addressLine1: "addressLine1",
  addressLine2: "addressLine2",
  addressLine3: "addressLine3",
  city: "city",
  state: "citySubdivision1",
  postalCode: "postalCode",
  country: "country",
  county: "county",
  phoneNumber: "phoneNumber",
};

export const toCheckoutValidationErrors = (validationErrors: ValidationError[]) =>
  toAddressFormValidationErrors(validationErrors, CHECKOUT_FIELD_BY_ADDRESS_ELEMENT);
